import React from "react";
import { Award, ShieldCheck, Building2, HardDrive, Globe2, Cpu } from "lucide-react";

const PARTNERS = [
  { name: "Securepoint Partner", icon: ShieldCheck },
  { name: "Greenbone Certified", icon: ShieldCheck },
  { name: "Acronis Cyber Backup", icon: HardDrive },
  { name: "Microsoft 365", icon: Globe2 },
  { name: "IHK Fulda Mitglied", icon: Building2 },
  { name: "Made in Germany", icon: Cpu },
];

export const PartnersStrip = () => (
  <section className="bg-white border-y border-line" data-testid="partners-strip">
    <div className="max-w-7xl mx-auto px-6 sm:px-12 py-12 sm:py-14">
      <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.25em] text-muted mb-8">
        <Award size={14} className="text-accent" />
        Partner · Zertifizierungen · Mitgliedschaften
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-line">
        {PARTNERS.map((p) => (
          <div
            key={p.name}
            className="bg-white p-5 flex flex-col items-center justify-center text-center gap-3 hover:bg-soft transition-colors min-h-[110px]"
          >
            <p.icon size={22} className="text-primary" />
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink leading-tight">
              {p.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
